"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialUrlsBuilderCreator = void 0;
var url_1 = require("../utils/url/url");
var social_sharing_types_1 = require("./social-sharing-types");
var socialUrlsBuilderCreator = function (album, settings) {
    var _a;
    return (_a = {},
        _a[social_sharing_types_1.SOCIAL_SHARING_SERVICES.BLOGGER] = function (sharetItem) {
            var siteUrl = settings.siteUrl;
            var params = (0, url_1.createParam)({
                u: siteUrl,
                n: sharetItem.title,
            });
            return "https://www.blogger.com/blog-this.g?".concat(params);
        },
        _a[social_sharing_types_1.SOCIAL_SHARING_SERVICES.TWITTER] = function (sharetItem) {
            var siteUrl = settings.siteUrl;
            var params = (0, url_1.createParam)({
                original_referer: siteUrl,
                text: "".concat(siteUrl, " ").concat(sharetItem.title),
            });
            return "https://twitter.com/intent/tweet?".concat(params);
        },
        _a[social_sharing_types_1.SOCIAL_SHARING_SERVICES.TUMBLR] = function () {
            var siteUrl = settings.siteUrl;
            var params = (0, url_1.createParam)({
                url: siteUrl,
            });
            return "https://www.tumblr.com/share/link?".concat(params);
        },
        _a);
};
exports.socialUrlsBuilderCreator = socialUrlsBuilderCreator;
//# sourceMappingURL=social-urls-builder-creator.js.map